import FailConfirmation from './FailConfirmation.component';
export default FailConfirmation;